import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoggerHandlerServiceAbstract } from '../abstract/logger-handler-service.abstract';

/**
 * LogHandlingService gives you an option to use a LoggerService service
 * in case you can't inject it (LoggerService) because of cyclic dependency!
 */
@Injectable()
export class LoggerHandlerService extends LoggerHandlerServiceAbstract {
    public log = new Subject();
    public warning = new Subject();
    public error = new Subject();
    public fatal = new Subject();

    public logCompleted = new Subject();
    public warningCompleted = new Subject();
    public errorCompleted = new Subject();
    public fatalCompleted = new Subject();
}
